const antdTheme = {
  components: {
    Table: {
      rowHoverBg: "#D6EAF8",
    },
  },
};

export default antdTheme;
